// x-header-tools.js

export default function xHeaderTools() {

	const body = document.body;
  const searchExpandButton = document.querySelector(".toggle-search");
	const menuExpandButton = document.querySelector(".sidebar-menu-toggle");
	const searchForm = document.querySelector("#header-search-form");
	const menu = document.querySelector(".sidebar-menu-wrapper");



	/**************************************************************************
	 * Search - open/close with expand button
	***************************************************************************/

	if (searchExpandButton) {
		searchExpandButton.addEventListener("click", function() {
			// Open
			if (searchExpandButton.getAttribute("aria-expanded") == "false") {
				searchExpandButton.setAttribute("aria-expanded", "true");
				body.classList.add("header-search-visible");

				// Set focus on input when css transition complete
				document.getElementById("header").addEventListener("transitionend", function() {
					document.getElementById("header-search-string").focus();
				});
			}
			// Close
			else {
				searchExpandButton.setAttribute("aria-expanded", "false");
				body.classList.remove("header-search-visible");
			}
		});

		// Search - close if press escape key
		document.addEventListener("keydown", function(event) {
			if(event.key == "Escape") {
				searchExpandButton.setAttribute("aria-expanded", "false");
				body.classList.remove("header-search-visible");
				// If focus is inside search form, set it back on the expand button
				if (searchForm.contains(document.activeElement)) {
					searchExpandButton.focus();
				}
			}
		});
	}



	/**************************************************************************
	 * Menu - open/close with expand button
	***************************************************************************/

	if (menuExpandButton) {
		// Use height of menu child to determine needed height when opening.
		const innerMenu = document.querySelector(".sidebar-menu");
		let innerMenuHeight = innerMenu.getBoundingClientRect().height;

		// Set variable for open state height that is then used by css.
		menu.style.setProperty("--open", innerMenuHeight + "px");

		menuExpandButton.addEventListener("click", function() {
			// Open
			if (menuExpandButton.getAttribute("aria-expanded") == "false") {
				menuExpandButton.setAttribute("aria-expanded", "true");
				body.classList.add("sidebar-menu-wrapper-visible");

				// Get inner menu height on each opening click, in case of space changes
				innerMenuHeight = innerMenu.getBoundingClientRect().height;
				menu.style.setProperty("--open", innerMenuHeight + "px");
			}
			// Close
			else {
				menuExpandButton.setAttribute("aria-expanded", "false");
				body.classList.remove("sidebar-menu-wrapper-visible");
			}
		});

		// Menu - close if press escape key
		document.addEventListener("keydown", function(event) {
			if(event.key == "Escape") {
				menuExpandButton.setAttribute("aria-expanded", "false");
				body.classList.remove("sidebar-menu-wrapper-visible");
				// If focus is inside menu, set it back on menu expand button
				if (menu.contains(document.activeElement)) {
					menuExpandButton.focus();
				}
			}
		});
	}
}


